/**
 * Created by Jan on 12.05.2017.
 */


(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.DomIdentifying = Lfl.DomIdentifying || {};

    (function (DomIdentifying, $, undefined) {
        if(Lfl.Files.isLoadedAlready(Lfl.DomIdentifying, 'IdsGenerator')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Generates ids (useable as HTML id attribute) for DOM elements.
         *
         * @memberOf Lfl.DomIdentifying
         */
        Lfl.DomIdentifying.IdsGenerator = DomIdentifying.IdsGenerator || {};

        (function (IdsGenerator, $, undefined) {
            /*
             |===========================================================================================================
             | Object definition
             |===========================================================================================================
             */

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */
            /**
             * Gets the element's id, if present, or generates and stores a new one.
             *
             * TODO MOBA II - consider adding a check for ids uniqueness. Should just throw an error (we can not solve
             * that without breaking any code that would depend on such an identifier.)
             *      Upd: Consider using our own identifier data- attribute? E.g. data-lfl-id ? So that we can have an
             *      unique "id" but not an id?
             *          Still does not solve the issue - if anyone depends on this lfl-id, we cannot change it.
             *
             * Note: We only handle the first element and assume that there is only one
             *
             * @param {jQuery| HTMLElement} $element
             * @return {string} The id of the element (either generated or already present).
             * @memberOf Lfl.DomIdentifying.IdsGenerator
             */
            IdsGenerator.getOrGenerateId = function($element) {
                if($element.length !== 1) {
                    console.warn("IdsGenerator: The $element should contain exactly one element. " +
                        "It contains: " + $element.length);
                }

                if (typeof $element.attr('id') === 'undefined') {
                    return IdsGenerator.markWithUniqueId($element);
                }

                return $element.attr('id');
            };

            /**
             * Generates an unique id for the given element and stores this id as it's id attribute.
             *
             * @param {jQuery| HTMLElement} $element
             * @return {string} The generated id.
             * @memberOf Lfl.DomIdentifying.IdsGenerator
             */
            IdsGenerator.markWithUniqueId = function($element) {
                if (typeof $element.attr('id') !== 'undefined') {
                    throw new Error("Trying to mark element with ID but it already has one. If you insist on replacing "
                        + "the old ID attribute, then remove it manually first.");
                }

                var element = $element.get(0);

                var firstClass = element.className.trim().split(/\s/)[0];
                var tag = element.tagName.toLowerCase();
                var hash = FullDomPathProvider.getFullDomPath($element, true).hashCode();
                var timestamp = new Date().valueOf();
                var rand = getRandomInt(100000, 1000000); // Uniform length

                var id = firstClass + "--" + tag + "-" + hash + "-" + timestamp + "-" + rand;

                $element.attr('id', id);

                return id;
            };
            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */

            // Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
            function getRandomInt(min, max) {
                min = Math.ceil(min);
                max = Math.floor(max);
                return Math.floor(Math.random() * (max - min)) + min;
            }

        }(DomIdentifying.IdsGenerator, jQuery));
    }(Lfl.DomIdentifying, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));